import { Component, ChangeDetectionStrategy } from '@angular/core'
import { ProductionListComponent } from '../production-list/production-list.component'
import { FacilityContextMenuComponent } from '../../../context/facility-context/facility-context-menu/facility-context-menu.component'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderToolbarColumnDirective,
} from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-production-list-viewer',
  templateUrl: './production-list-viewer.component.html',
  styleUrls: ['./production-list-viewer.component.scss'],
  imports: [
    ElderToolbarColumnDirective,
    FacilityContextMenuComponent,
    ProductionListComponent,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class ProductionListViewerComponent {
  constructor() {}
}
